// extracted by mini-css-extract-plugin
export var gutterSpacer = "layout-module--gutterSpacer--1mq-J";
export var container = "layout-module--container--11J_e";
export var colWrapper = "layout-module--colWrapper--n_Xsy";
export var hiddenInMobile = "layout-module--hiddenInMobile--1thlf";
export var visibleInMobileOnly = "layout-module--visibleInMobileOnly--aEu8o";
export var hiddenInPhablet = "layout-module--hiddenInPhablet--BXQhd";